import { SalesforceCreateCallComponent } from '../salesforce-create-call/salesforce-create-call.component';
import { UpdateFieldComponent } from '../update-field/update-field.component';
import { ITriggerConfig } from './shared-action-configurations';

const capitaliseFirstChar = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

export class SalesforceActionConfigurations {
  private static documentSaveConfig: ITriggerConfig = {
    id: 'post-SaveToEntity',
    title: () => 'Document save actions',
    description: () => 'Actions taken when a document is saved',
    actions: {
      [SalesforceCreateCallComponent.NAME]: {},
      [UpdateFieldComponent.NAME]: (UpdateFieldComponent.IUpdateFieldConfig = {
        showDateSentOption: false,
        showDateSavedOption: true,
        showDocusignOption: false,
      }),
    },
  };

  private static receivedFromSignatureConfig: ITriggerConfig = {
    id: 'post-ReceivedFromSignature',
    title: (signatureName: string) => `Received from ${capitaliseFirstChar(signatureName)} actions`,
    description: (signatureName: string) => `Actions taken when a document is received from ${capitaliseFirstChar(signatureName)}`,
    actions: {
      [UpdateFieldComponent.NAME]: (UpdateFieldComponent.IUpdateFieldConfig = {
        showDateSentOption: false,
        showDateSavedOption: false,
        showDocusignOption: true,
      }),
      [SalesforceCreateCallComponent.NAME]: {},
    },
  };

  private static signatureSentConfig: ITriggerConfig = {
    id: 'post-SendForSignature',
    title: (signatureName: string) => `Send/Edit in ${capitaliseFirstChar(signatureName)} actions`,
    description: (signatureName: string) => `Actions taken when a document is sent to ${capitaliseFirstChar(signatureName)}`,
    actions: {
      [UpdateFieldComponent.NAME]: (UpdateFieldComponent.IUpdateFieldConfig = {
        showDateSentOption: true,
        showDateSavedOption: false,
        showDocusignOption: false,
      }),
      [SalesforceCreateCallComponent.NAME]: {},
    },
  };

  static triggerConfigs: ITriggerConfig[] = [
    SalesforceActionConfigurations.documentSaveConfig,
    SalesforceActionConfigurations.receivedFromSignatureConfig,
    SalesforceActionConfigurations.signatureSentConfig,
  ];

}
